/**
 * Customer marketplace access (B2C vs future B2B).
 * Mirror of nemacareBE/config/customerAccessPolicy.js — keep defaults in sync.
 *
 * B2C default: no Aadhaar KYC onboarding, no admin approval wait.
 * For B2B: set REACT_APP_NEMA_REQUIRE_CUSTOMER_AADHAAR_KYC=true
 * (and optionally REACT_APP_NEMA_REQUIRE_CUSTOMER_KYC_ADMIN_APPROVAL=true).
 */

function envFlag(name, defaultValue = false) {
  const raw = process.env[name];
  if (raw == null || String(raw).trim() === "") return defaultValue;
  return /^(1|true|yes|on)$/i.test(String(raw).trim());
}

export function isCustomerAadhaarKycRequired() {
  return envFlag("REACT_APP_NEMA_REQUIRE_CUSTOMER_AADHAAR_KYC", false);
}

export function isCustomerKycAdminApprovalRequired() {
  if (!isCustomerAadhaarKycRequired()) return false;
  return envFlag("REACT_APP_NEMA_REQUIRE_CUSTOMER_KYC_ADMIN_APPROVAL", true);
}

/** Hide KYC forms, banners, and post-auth redirects when B2C flags are off. */
export function shouldShowCustomerAadhaarKycUi() {
  return isCustomerAadhaarKycRequired();
}
